<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="contactos-view">
      <div class="page-title" style="background-color: #000;">
        <div class="auto-container">
          <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
        </div>
      </div>
      <section class="contacto-sucesso">
        <div class="auto-container" style="max-width: 550px;">
          <div class="sucesso-icon">
            <span class="icon pi pi pi-check"></span>
          </div>
          <div class="sucesso-title">
            <span class="sectionTitle" v-html="fc_getText(null, 'contacto-geral_title')"></span>
          </div>
          <h3 class="mt-3 mb-4" >{{ fc_getText(null, 'contacto-geral_subtitle') }}</h3>
          <div class="sucesso-text mb-3">
            <p v-html="fc_getText(null, 'contacto-geral_text1')"></p>
            <p v-html="fc_getText(null, 'contacto-geral_text2')"></p>
          </div>
          <div class="btn sucesso-button mt-3" style="display: inline-block">
            <div @click="fc_goRoute('home')" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_contacto-geral')"></div>
          </div>
        </div>
      </section>
      <section class="contactos-infoSection">
        <div class="inner-container">
          <div class="flex flex-wrap">
            <div class="info-block w-full md:w-4">
              <div class="inner-box">
                <div class="icon-box wow fade-zoom"><span class="icon pi pi-map-marker"></span></div>
                <div v-if="(item.moradaArteria != '')" class="text-box" v-html="mt_getMorada()"></div>
              </div>
            </div>
            <div class="info-block w-full md:w-4">
              <div class="inner-box">
                <div class="icon-box wow fade-zoom-2"><span class="icon pi pi-envelope"></span></div>
                <div v-if="(item.email != '')" class="text-box"><a :href="'mailto:'+item.email"> {{ item.email }}</a></div>
                <div v-if="(item.emailAlternativo != '')" class="text-box"><a :href="'mailto:'+item.emailAlternativo">{{ item.emailAlternativo }}</a></div>
              </div>
            </div>
            <div class="info-block w-full md:w-4">
              <div class="inner-box">
                <div class="icon-box wow fade-zoom-3"><span class="icon pi pi-phone"></span></div>
                <div v-if="(item.telefone != '')" class="text-box" v-html="item.telefone"></div>
                <div v-if="(item.chamadaRedeFixa)" class="text-box" v-html="fc_getText(null, 'chamadaRedeFixa')"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: false,
      item: {},
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      setTimeout(() => {
        this.loaded = true;
      }, 400)
    },
    mt_getMorada() {
      let strMorada = this.item.moradaArteria + '</br>' + this.item.moradaCp +  ' ' + this.item.moradaCpAlf;
      strMorada += (this.item.linkGoogleMaps != ''? '<br/><a href="' + this.item.linkGoogleMaps + '" target="_blank" style="font-size:17px;" ><strong>'+ this.fc_getText(null,'mapa')+'</strong></a></p>' : '');
      return strMorada;
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ContactosPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
  .contactos-content {
    padding:100px 0px;
  }
  .contactos-content .title-group {
    margin-bottom: 30px;
  }

  .contacto-sucesso {
    padding: 80px 20px;
    text-align: center;
    background: #fff;
  }
  .contacto-sucesso .sucesso-icon {
    width: 120px;
    height: 120px;
    border: 4px solid var(--ibase-color);
    border-radius: 50%;
    margin: 0 auto 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contacto-sucesso .sucesso-icon .pi {
    font-size: 55px;
    color: var(--ibase-color);
    font-weight: bold;
  }
  .contacto-sucesso .sucesso-title {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contacto-sucesso h3 {
    position: relative;
    color: #3c4858;
    font-size: 32px;
    font-weight: 500;
  }
  @media only screen and (max-width: 767px) {
    .contacto-sucesso h3 {
      font-size: 25px;
    }
  }
  .contacto-sucesso .sucesso-text p {
    font-size: 14px;
    line-height: 25px;
    color: #3c4858;
    font-weight: 500;
    margin-bottom: 13px;
  }

  .contactos-infoSection {
    background-color: #f9f9f9 !important;
    position: relative;
    padding: 75px 0 25px;
  }
  .contactos-infoSection .inner-container {
    max-width: 1060px;
    margin: 0 auto;
    padding: 0 15px;
  }
  .contactos-infoSection .info-block {
    position: relative;
    margin-bottom: 50px;
  }
  .contactos-infoSection .info-block .inner-box {
    position: relative;
    text-align: center;
  }
  .contactos-infoSection .info-block .icon-box {
    position: relative;
    display: inline-block;
    height: 135px;
    width: 135px;
    border-radius: 50%;
    text-align: center;
    font-size: 48px;
    color: #ffffff;
    line-height: 135px;
    background-color: black;
    margin-bottom: 25px;
    transition: all 300ms ease;
  }
  .contactos-infoSection .info-block .text-box {
    display: block;
    font-size: 14px;
    line-height: 25px;
    color: #3c4858;
    font-weight: 500;
  }
  .contactos-infoSection .info-block p {
    display: block;
    font-size: 14px;
    line-height: 25px;
    color: #3c4858;
    font-weight: 500;
  }
</style>
